/* eslint-disable camelcase */
import i18n from 'i18next';

import SelectOptionWithCode from '@/exceed/components/selectOptionWithCode';

const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
const documentTypes = [
    'application/vnd.google-apps.document',
    'application/vnd.google-apps.spreadsheet',
    'application/vnd.google-apps.presentation',
    'application/vnd.google-apps.drawing',
    'application/vnd.google-apps.form',
    'application/vnd.google-apps.site',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'application/pdf'
];

// To abide by the technical limits of Gemini 2.5 pro
// https://cloud.google.com/vertex-ai/generative-ai/docs/models/gemini/2-5-pro
const maxSizePerMimeType = (mimeType) => {
  if (imageTypes.includes(mimeType)) {
    return 7; // 7MB
  }
  if (documentTypes.includes(mimeType)) {
    return 50; // 50MB
  }
  if (mimeType.startsWith('video/')) {
    return 2200; // ~2.2GB (approx size of a 1 hour video with 1080p and 5 Mbps)
  }
  if (mimeType.startsWith('audio/')) {
    // It covers up to MP3 320kbps for 8.4 hours.
    // Allows a bit of buffer for metadata or slight overages.
    return 1500; // ~1.5GB
  }
  return 500; // 500MB
};

export default ({
  catalogActivitySchema,
  fileUploadSchema,
  googleDriveSchema,
  oneDriveSchema,
}) => ({
  source_content_type: {
    type: 'Select',
    label: i18n.t('course-properties.material-source'),
    help: i18n.t('course-properties.material-source-help'),
    isFluid: true,
    options: [
      {
        label: i18n.t('course-properties.catalog-activity'),
        value: 'catalog_activity',
      },
      {
        label: i18n.t('course-properties.file-upload'),
        value: 'file_upload',
      },
      {
        label: i18n.t('course-properties.google-drive'),
        value: 'google_drive',
      },
      {
        label: i18n.t('course-properties.one-drive'),
        value: 'one_drive',
      },
    ],
    validators: [{ type: 'isRequired' }],
  },
  catalog_activity: {
    type: 'CatalogActivity',
    label: i18n.t('course-properties.catalog-activity'),
    help: i18n.t('course-properties.catalog-activity-help'),
    selectProps: {
      components: { Option: SelectOptionWithCode },
      isFullWidth: true,
      placeholder: i18n.t('course-properties.catalog-activity-placeholder'),
    },
    conditions: [{ type: 'isNotCatalogActivity', shouldHideField: true }],
    ...catalogActivitySchema,
  },
  file_upload: {
    type: 'FileUpload',
    label: i18n.t('course-properties.file-upload'),
    help: i18n.t('course-properties.file-upload-help'),
    uploadType: 'document',
    maxUploadSizeInMb: maxSizePerMimeType,
    isDisabled: false,
    conditions: [{ type: 'isNotFileUpload', shouldHideField: true }],
    ...fileUploadSchema,
  },
  google_drive: {
    type: 'GoogleDrivePicker',
    label: i18n.t('course-properties.google-drive'),
    help: i18n.t('course-properties.google-drive-help'),
    maxUploadSize: 3000,
    conditions: [{ type: 'isNotGoogleDrive', shouldHideField: true }],
    ...googleDriveSchema,
  },
  one_drive: {
    type: 'OneDrive',
    label: i18n.t('course-properties.one-drive'),
    help: i18n.t('course-properties.one-drive-help'),
    maxUploadSize: 3000,
    conditions: [{ type: 'isNotOneDrive', shouldHideField: true }],
    ...oneDriveSchema,
  },
});
